import React, { useState } from 'react';
import './App.css';

export default function AlgoTradingBot() {
  const [webhookUrl] = useState("https://vyodha-api.supabase.co/webhook/v1/trade-signal");
  const [isBotActive, setIsBotActive] = useState(false);
  const [webhookLogs, setWebhookLogs] = useState([
    { id: 1, time: "10:00 AM", status: "ONLINE", message: "Webhook listener initialized and secure." }
  ]);

  const toggleBot = () => {
    setIsBotActive(!isBotActive);
    const newLog = {
      id: Date.now(),
      time: new Date().toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' }),
      status: !isBotActive ? "ACTIVATED 🟢" : "STOPPED 🔴",
      message: !isBotActive ? "Bot is now listening for incoming JSON payloads from TradingView." : "Webhook listener paused."
    };
    setWebhookLogs(prev => [newLog, ...prev]);
  };

  return (
    <div style={{ padding: '30px', height: '100%', overflowY: 'auto', backgroundColor: 'var(--bg-main)', color: 'var(--text-main)', boxSizing: 'border-box' }}>
      
      {/* Header */}
      <div style={{ marginBottom: '25px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <div>
          <h2 style={{ color: 'var(--vyodha-gold)', fontSize: '24px', marginBottom: '6px', fontFamily: "'Cinzel', serif" }}>
            ⚡ Algorithmic Webhook & Signal Engine
          </h2>
          <p style={{ color: 'var(--text-muted)', fontSize: '13px', margin: 0 }}>
            Automate trade execution via TradingView alerts, Python scripts, or custom JSON webhooks.
          </p>
        </div>
        <button onClick={toggleBot} style={{ backgroundColor: isBotActive ? '#FF1744' : '#00C853', color: '#fff', border: 'none', padding: '12px 24px', borderRadius: '8px', fontWeight: 'bold', cursor: 'pointer' }}>
          {isBotActive ? 'STOP ALGO ENGINE' : 'START ALGO ENGINE'}
        </button>
      </div>

      {/* Webhook Endpoint Box */}
      <div style={{ backgroundColor: 'var(--bg-panel)', border: '1px solid var(--border-color)', borderRadius: '12px', padding: '20px', marginBottom: '25px' }}>
        <h3 style={{ fontSize: '15px', color: 'var(--vyodha-gold)', marginBottom: '8px' }}>🔗 Secure Webhook Endpoint URL</h3>
        <p style={{ color: 'var(--text-muted)', fontSize: '12px', marginBottom: '12px' }}>Paste this URL into your TradingView alert webhook settings:</p>
        <div style={{ display: 'flex', gap: '10px', alignItems: 'center', backgroundColor: 'var(--bg-main)', padding: '10px 14px', borderRadius: '8px', border: '1px solid var(--border-color)' }}>
          <code style={{ flex: 1, color: '#00C853', fontSize: '13px' }}>{webhookUrl}</code>
          <button onClick={() => { navigator.clipboard.writeText(webhookUrl); alert("Webhook URL copied to clipboard!"); }} style={{ backgroundColor: '#D4AF37', color: '#000', border: 'none', padding: '6px 12px', borderRadius: '6px', fontWeight: 'bold', cursor: 'pointer', fontSize: '12px' }}>Copy</button>
        </div>
      </div>

      {/* Live Webhook Logs */}
      <div style={{ backgroundColor: 'var(--bg-panel)', border: '1px solid var(--border-color)', borderRadius: '12px', padding: '20px' }}>
        <h3 style={{ fontSize: '15px', color: 'var(--vyodha-gold)', marginBottom: '15px' }}>📋 Live Signal Audit Log</h3>
        <table className="positions-table" style={{ width: '100%', borderCollapse: 'collapse' }}>
          <thead>
            <tr style={{ borderBottom: '1px solid var(--border-color)', textAlign: 'left', color: 'var(--text-muted)', fontSize: '12px' }}>
              <th style={{ padding: '8px' }}>Time</th>
              <th style={{ padding: '8px' }}>Status</th>
              <th style={{ padding: '8px' }}>Payload Message</th>
            </tr>
          </thead>
          <tbody>
            {webhookLogs.map(log => (
              <tr key={log.id} style={{ borderBottom: '1px solid var(--border-color)' }}>
                <td style={{ padding: '10px', fontSize: '12px' }}>{log.time}</td>
                <td style={{ padding: '10px', fontWeight: 'bold', color: log.status.includes('ACTIVATED') || log.status.includes('ONLINE') ? '#00C853' : '#FF1744', fontSize: '12px' }}>{log.status}</td>
                <td style={{ padding: '10px', fontSize: '13px' }}>{log.message}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

    </div>
  );
}